import toArray from './../../scripts/to-array';

toArray(document.querySelectorAll('[data-component="careers-gallery"]')).forEach((component) => {
  const backButton = component.querySelector('[data-careers-gallery-back]');

  if (backButton) {
    backButton.addEventListener('click', () => {
      const sameOrigin = document.referrer.match(new RegExp(`^https?://(${window.location.host})/?.*`, 'g'));
      if (sameOrigin) {
        window.history.back();
      } else {
        window.location = backButton.dataset.href;
      }
    });
  }
});
